import axios from 'axios';
import { toast } from 'sonner';

const api = axios.create({
    baseURL: `${import.meta.env.VITE_BACKEND_URL}/api`,
    withCredentials: true
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (
            error.response?.status === 401 &&
            !error.config?.url?.includes('/auth/')
        ) {
            window.dispatchEvent(new CustomEvent('session-expired'));
        }
        return Promise.reject(error);
    }
);

/**
 * Extract a user-friendly message from an API error.
 * Shows a toast unless `silent` is true. Returns the message string.
 */
export function handleApiError(err, { fallback = 'Something went wrong', silent = false } = {}) {
    const message = err?.response?.data?.detail || fallback;
    if (!silent) toast.error(message);
    return message;
}

export function photoUrl(path) {
    if (!path) return '';
    if (path.startsWith('http')) return path;
    return `${import.meta.env.VITE_BACKEND_URL}${path}`;
}

export default api;
